<template>

<section id='MyProfile'>
    <Verification v-if='isModalVisible' @close='closeModal' @verify='verify' :user="user"></Verification>
    <div class='row' v-else>
        <div class="col-12">
            <VerificationBoard @showModal="showModal" :user="user"/>
        </div>
        <div class="col-12 col-md-6">
            <cards-component
            :cards="cards"
            :cards_count="cards_count"
            :flag="newCardFlag"
            :bank_list="bank_list">
            </cards-component>
        </div>
        <div class="col-12 col-md-6">
            <wallets-component
            @delete="delete_wallet"
            :crypto="cryptos"
            :wallets="wallets"
            :wallets_count="wallets_count"
            :flag="newWalletFlag">
            </wallets-component>
        </div>
    </div>
</section>
</template>
<script>
  import CryptoElementComponent from "@/components/Actives/CryptoElementComponent.vue";
  import Verification from "@/components/Actives/Verification.vue";
  import VerificationBoard from "@/components/Actives/VerificationBoard.vue";

  export default {
      props: [
          'courses',
          'user',
          'cards',
          'wallets',
          'cards_count',
          'wallets_count',
          'user_load',
          'cryptos',
          'balances',
          'bank_list',
          'currencies'
      ],
      components: {
          CryptoElementComponent,
          Verification,
          VerificationBoard
      },
      data: () => ({
        isModalVisible: false,
        newCardFlag: false,
        newWalletFlag: false,
      }),
      computed: {
          courses_BTC2USDT_rate() {
              return this.courses.find(c => (c.pair == 'BTC-USDT'))?.rate ?? 0;
          },
      },
      methods: {
        showModal() {
            if(this.$metrika !== undefined) {
                this.$metrika.reachGoal('pop_up_verification');
            }
            this.isModalVisible = true;
        },
          closeModal() {
              this.isModalVisible = false;
              this.$router.push('/profile');
          },
          verify(){
                this.$emit('verify');
            },
            delete_wallet(data) {
                this.$emit('del_wallet', data)
            },

      },
      created() {
        if(window.location.search.includes('modal')) {
            this.showModal();
        }
      }
  }
</script>

<style scoped>
  .lk__list p {
      font-size: 12px;
      font-family: Montserrat;
      Line-height: 17px;
  }
  .lk__list span {
      font-size: 15px;
  }

  .f14, .f14 span {
      font-size: 14px;
  }

  .f15, .f15 span {
      font-size: 15px;
  }
  .f17 .f17 span {
      font-size: 17px;
  }

  .no_min_height {
      min-height: unset !important;
  }

</style>
